import { useEffect, Suspense } from 'react';
import { Route, useNavigate, useLocation, Routes } from 'react-router';

import CharityVettingAcceptsAllFoodAndNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodAndNonFoodEntry';
import CharityVettingAcceptsAllFoodsEntry from '../../../common-flow/entries/CharityVettingAcceptsAllFoodsEntry';
import CharityVettingAcceptsAllNonFoodEntry from '../../../common-flow/entries/CharityVettingAcceptsAllNonFoodEntry';
import CharityVettingConsumptionTypeEntry from '../../../common-flow/entries/CharityVettingConsumptionTypeEntry';
import CharityVettingContactDetailsEntry from '../../../common-flow/entries/CharityVettingContactDetailsEntry';
import CharityVettingDonationPreferencesEntry from '../../../common-flow/entries/CharityVettingDonationPreferencesEntry';
import CharityVettingGetStartedEntry from '../../../common-flow/entries/CharityVettingGetStartedEntry';
import CharityVettingLegalRepresentativeEntry from '../../../common-flow/entries/CharityVettingLegalRepresentativeEntry';
import CharityVettingManualContactDetailsEntry from '../../../common-flow/entries/CharityVettingManualContactDetailsEntry';
import CharityVettingReviewDetailsEntry from '../../../common-flow/entries/CharityVettingReviewDetailsEntry';
import CharityVettingSearchDetailsEntry from '../../../common-flow/entries/CharityVettingSearchDetailsEntry';
import CharityVettingSocialAccountsEntry from '../../../common-flow/entries/CharityVettingSocialAccountsEntry';
import CharityVettingUnwantedFoodEntry from '../../../common-flow/entries/CharityVettingUnwantedFoodEntry';
import { vettingPath } from '../../../common-flow/entries/path';

import CharityVettingFiscalBenefitsRoute from './CharityVettingFiscalBenefitsRoute';
import CharityVettingHACCPCertificateRoute from './CharityVettingHACCPCertificateRoute';
import CharityVettingHACCPRoute from './CharityVettingHACCPRoute';
import CharityVettingNIFRoute from './CharityVettingNIFRoute';
import CharityVettingNIPCRoute from './CharityVettingNIPCRoute';
import CharityVettingPreparationKitchenRoute from './CharityVettingPreparationKitchenRoute';
import CharityVettingTypeRoute from './CharityVettingTypeRoute';

const CharityVettingRoutesPT = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === vettingPath.basePath) {
      navigate(vettingPath.getStartedPath, { replace: true });
    }
  }, []); // eslint-disable-line  react-hooks/exhaustive-deps

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={vettingPath.getStartedPath} element={<CharityVettingGetStartedEntry />} />
        <Route path={vettingPath.searchPath} element={<CharityVettingSearchDetailsEntry />} />
        <Route
          path={vettingPath.contactDetailsPath}
          element={<CharityVettingContactDetailsEntry />}
        />
        <Route
          path={vettingPath.manualContactDetailsPath}
          element={<CharityVettingManualContactDetailsEntry />}
        />
        <Route
          path={vettingPath.legalRepresentativePath}
          element={<CharityVettingLegalRepresentativeEntry />}
        />
        <Route path={vettingPath.registrationPath} element={<CharityVettingTypeRoute />} />
        <Route path={vettingPath.nifPath} element={<CharityVettingNIFRoute />} />
        <Route path={vettingPath.nipcPath} element={<CharityVettingNIPCRoute />} />
        <Route
          path={vettingPath.fiscalBenefitsPath}
          element={<CharityVettingFiscalBenefitsRoute />}
        />
        <Route
          path={vettingPath.donationPreferencesPath}
          element={<CharityVettingDonationPreferencesEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodsPath}
          element={<CharityVettingAcceptsAllFoodsEntry />}
        />
        <Route
          path={vettingPath.acceptAllNonFoodPath}
          element={<CharityVettingAcceptsAllNonFoodEntry />}
        />
        <Route
          path={vettingPath.acceptAllFoodAndNonFoodPath}
          element={<CharityVettingAcceptsAllFoodAndNonFoodEntry />}
        />
        <Route path={vettingPath.unwantedFoodPath} element={<CharityVettingUnwantedFoodEntry />} />
        <Route
          path={vettingPath.preparationKitchenPath}
          element={<CharityVettingPreparationKitchenRoute />}
        />
        <Route
          path={vettingPath.consumptionTypePath}
          element={<CharityVettingConsumptionTypeEntry />}
        />
        <Route path={vettingPath.haccpPath} element={<CharityVettingHACCPRoute />} />
        <Route
          path={vettingPath.haccpCertificatePath}
          element={<CharityVettingHACCPCertificateRoute />}
        />
        <Route
          path={vettingPath.socialAccountsPath}
          element={<CharityVettingSocialAccountsEntry />}
        />
        <Route
          path={vettingPath.reviewDetailsPath}
          element={<CharityVettingReviewDetailsEntry />}
        />
      </Routes>
    </Suspense>
  );
};

export default CharityVettingRoutesPT;
